var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_58893_10454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.405 3.75C5.45 4.4175 5.5625 5.07 5.7425 5.6925L4.8425 6.5925C4.535 5.6925 4.34 4.74 4.2725 3.75H5.405ZM12.8 12.765C13.4375 12.945 14.09 13.0575 14.75 13.1025V14.22C13.76 14.1525 12.8075 13.9575 11.9 13.6575L12.8 12.765ZM6.125 2.25H3.5C3.0875 2.25 2.75 2.5875 2.75 3C2.75 10.0425 8.4575 15.75 15.5 15.75C15.9125 15.75 16.25 15.4125 16.25 15V12.3825C16.25 11.97 15.9125 11.6325 15.5 11.6325C14.57 11.6325 13.6625 11.4825 12.8225 11.205C12.7475 11.175 12.665 11.1675 12.59 11.1675C12.395 11.1675 12.2075 11.2425 12.0575 11.385L10.4075 13.035C8.285 11.9475 6.545 10.215 5.465 8.0925L7.115 6.4425C7.325 6.2325 7.385 5.94 7.3025 5.6775C7.025 4.8375 6.875 3.9375 6.875 3C6.875 2.5875 6.5375 2.25 6.125 2.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58893_10454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/PhoneWhite.7f7f298dfbc88907c054e3575f8c8ca2.svg";
export { ForwardRef as ReactComponent };